import React, { createContext, useContext, useState, ReactNode } from "react";
import { Project } from "../models/project.ts";

interface ProjectContextType {
  project: Project;
  setProject: (project: Project) => void;
}

export const defaultProject: Project = {
    name: "", 
    article_number: "",
    notes: "",
    company: {
      name: "",
      street: "",
      city: "",
      country: "",
    },
    ask_for_user: true
};

const ProjectContext = createContext<ProjectContextType | undefined>(undefined);

export const useProject = () => {
  const ctx = useContext(ProjectContext);
  if (!ctx) throw new Error("useProject must be used within a ProjectProvider");
  return ctx;
};

export const ProjectProvider = ({ children }: { children: ReactNode }) => {
  const [project, setProject] = useState<Project>(defaultProject);
  return (
    <ProjectContext.Provider value={{ project, setProject }}>
      {children}
    </ProjectContext.Provider>
  );
};
